module.exports = __webpack_public_path__ + "img/salchipapas.cf532a64.jpeg";